import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: _ctx.isValid,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isValid) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        style: {"min-width":"700px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_alert, {
            modelValue: _ctx.notAvailable,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.notAvailable) = $event)),
            type: "error",
            text: "Ce produit est en rupture de stock"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          (_ctx.stockOperationType === 'OUTPUT')
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "3",
                class: "pr-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select_filled, {
                    modelValue: _ctx.operateBy,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.operateBy) = $event)),
                    items: [
                        { title: 'Produit', value: 'Product' },
                        { title: 'Famille', value: 'Family' },
                    ],
                    label: "Opération selon",
                    "data-cy": "editStockOperation-family"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: _ctx.stockOperationType === 'OUTPUT' ? 'xs9 pl-1' : 'xs12'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_oss_date_picker_filled, {
                modelValue: _ctx.date,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.date) = $event)),
                filterWithoutClosedAccountingPeriods: true,
                "hide-details": "",
                textFieldReadOnly: false,
                readonly: _ctx.readonly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _: 1
          }, 8, ["cols"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "py-2"
      }, {
        default: _withCtx(() => [
          (_ctx.operateBy === 'Product')
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                class: "pr-1",
                cols: _ctx.showPrice ? '3' : _ctx.showSalesPrice ? '4' : '6'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select_filled, {
                    modelValue: _ctx.stockProductId,
                    "onUpdate:modelValue": [
                      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.stockProductId) = $event)),
                      _cache[4] || (_cache[4] = ($event: any) => (_ctx.computeQuantities()))
                    ],
                    items: _ctx.products,
                    label: "Produit",
                    "item-value": "id",
                    "data-cy": "editStockOperation-product",
                    readonly: _ctx.readonly,
                    "item-title": (item) => item.title
                  }, null, 8, ["modelValue", "items", "readonly", "item-title"])
                ]),
                _: 1
              }, 8, ["cols"]))
            : (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                class: "pr-1",
                cols: _ctx.showPrice ? '3' : '6'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select_filled, {
                    modelValue: _ctx.productTagId,
                    "onUpdate:modelValue": [
                      _cache[5] || (_cache[5] = ($event: any) => ((_ctx.productTagId) = $event)),
                      _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateQuantity()))
                    ],
                    items: _ctx.productTags,
                    "item-value": "id",
                    label: "Famille",
                    "data-cy": "editStockOperation-family",
                    readonly: _ctx.readonly,
                    "item-title": (item) => item.name
                  }, null, 8, ["modelValue", "items", "readonly", "item-title"])
                ]),
                _: 1
              }, 8, ["cols"])),
          (_ctx.withQuantity)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 2,
                cols: "3",
                class: "pr-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oss_text_field_filled, {
                    modelValue: _ctx.quantity,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.quantity) = $event)),
                    label: "Quantité achetée",
                    "data-cy": "editStockOperation-quantity",
                    rules: [(v) => _ctx.quantity > 0 || _ctx.$t('settings.positiveNumber')],
                    readonly: _ctx.readonly
                  }, null, 8, ["modelValue", "rules", "readonly"])
                ]),
                _: 1
              }))
            : (_ctx.withProductQuantity)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 3,
                  cols: _ctx.showSalesPrice ? '4' : '6',
                  class: "pr-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oss_text_field_filled, {
                      modelValue: _ctx.productQuantity,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.productQuantity) = $event)),
                      label: "Quantité de produit",
                      "data-cy": "editStockOperation-productQuantity",
                      rules: [(v) => _ctx.productQuantity > 0 || _ctx.$t('settings.positiveNumber')],
                      readonly: _ctx.readonly
                    }, null, 8, ["modelValue", "rules", "readonly"])
                  ]),
                  _: 1
                }, 8, ["cols"]))
              : _createCommentVNode("", true),
          (_ctx.showPrice)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 4,
                cols: "3",
                class: "pr-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field_filled, {
                    modelValue: _ctx.stockOperation.unitPrice,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.stockOperation.unitPrice) = $event)),
                    modelModifiers: { number: true },
                    suffix: "€",
                    type: "number",
                    label: "Prix d'achat HT unitaire",
                    "data-cy": "editStockOperation-unitPrice",
                    readonly: _ctx.readonly
                  }, null, 8, ["modelValue", "readonly"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.showPrice)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 5,
                cols: "3",
                class: "pl-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oss_text_field_filled, {
                    modelValue: _ctx.stockOperation.price,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.stockOperation.price) = $event)),
                    suffix: "€",
                    label: "Prix",
                    "data-cy": "editStockOperation-price",
                    readonly: _ctx.readonly
                  }, null, 8, ["modelValue", "readonly"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.showSalesPrice)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 6,
                cols: "4",
                class: "pl-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oss_text_field_filled, {
                    modelValue: _ctx.stockOperation.salesPrice,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.stockOperation.salesPrice) = $event)),
                    suffix: "€",
                    label: "Prix de vente",
                    "data-cy": "editStockOperation-sales-price",
                    readonly: _ctx.readonly
                  }, null, 8, ["modelValue", "readonly"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.withSubproducts)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_divider)
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quantities, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (index % 4 === 0)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      "no-gutters": "",
                      class: "pt-2"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                          return _createVNode(_component_v_col, {
                            cols: "3",
                            key: index + i
                          }, {
                            default: _withCtx(() => [
                              (_ctx.quantities[index + i - 1])
                                ? (_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                    key: 0,
                                    label: 'Quantité : ' + _ctx.quantities[index + i - 1].quantityName,
                                    class: _normalizeClass((i > 1 ? 'ml-1 ' : '') + 'oss-dark'),
                                    rules: [(v) => v >= 0 || _ctx.$t('settings.positiveNumber')],
                                    readonly: _ctx.readonly,
                                    modelValue: _ctx.quantities[index + i - 1].quantity,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.quantities[index + i - 1].quantity) = $event)
                                  }, null, 8, ["label", "class", "rules", "readonly", "modelValue", "onUpdate:modelValue"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        }), 64))
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}